import React from 'react'
import { AlertCircle, NotesIcon } from '../utils/icons'
import { Select } from 'antd'

function Notes() {
    return (
        <div>
            <div className='flex justify-between items-center mb-5'>
                <h1 className='font-semibold text-lg'>Notes</h1>
                <AlertCircle />
            </div>
            <div className='flex justify-center flex-col items-center gap-5 shadow-chatBoxShadow p-5 rounded-3xl'>
                <div className='flex items-center gap-3'>
                    <h1>Filter</h1>
                    <Select className='w-[300px] '>
                        <Select.Option key='One'>One</Select.Option>
                        <Select.Option key='Two'>Two</Select.Option>
                        <Select.Option key='Three'>Three</Select.Option>
                    </Select>
                </div>
                <NotesIcon />
                <p className='text-center text-sm'>You have not added any notes yet. Notes can be created from video pages.</p>
                <button className='bg-signupSubmitBtn rounded-3xl px-3 py-1 text-pureWhite'>Create New Note</button>
            </div>
        </div>
    )
}

export default Notes